require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.get-iterator');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.2.4.1@core-js/library/fn/get-iterator.js
 ** module id = 465
 ** module chunks = 0 1
 **/